import { ReactElement, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import InviteUserComponent from "../inviteUser/InviteUserComponent";
import { useGlobalContext } from "../../shared/GlobalContext";
import userLinkListTable from "../../shared/tableObjects/userLinkListTable";
import ComponentHeader from "../componentHeader/componentHeader";
import FrontEndTable from "../table/FrontEndTable";
import { apiClient } from "../../shared/customHooks";
import { RoleId } from "../../shared/enums/Role";
import { AuthorisationLevel } from "../../shared/enums/AuthorisationLevel";
import { UserLinksDiscriminator } from "../../shared/enums/LinkDiscriminator";

interface RepresentativeValues {
  roleType: RoleId;
  authorisationLevel?: AuthorisationLevel;
  userLinkDiscriminator?: UserLinksDiscriminator;
  providerName?: string;
}

interface AuthorisedRepresentativeComponentProps {
  inviteText?: string | ReactElement;
  tooltipText?: string;
  otherValues?: RepresentativeValues;
  id: string;
  data: any[];
  showInvite: boolean;
  label: string;
  advisory: string;
  domain?: string;
  apiClient?: apiClient;
  emailValidationMsg?: string;
}

export default function AuthorisedRepresentativeManagementComponent({
  otherValues,
  id,
  inviteText,
  tooltipText,
  data,
  apiClient,
  showInvite,
  label,
  advisory,
  domain,
  emailValidationMsg,
}: AuthorisedRepresentativeComponentProps) {
  const [visible, setVisible] = useState(false);
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  const handleHide = () => {
    setVisible(false);
  };

  return (
    <>
      {" "}
      <div className="p-5 authrep-table">
        <ComponentHeader label={"Authorised Representative Management"} />

        <div>
          {showInvite && (
            <>
              <div className="flex flex-col">
                <Button tooltip={tooltipText} label="Invite User" className="invite-button" onClick={() => setVisible(!visible)}></Button>{" "}
                {inviteText && <span className="text-left fieldadv mb-5 ">{inviteText}</span>}
              </div>
            </>
          )}
          <Dialog
            header="Invite User"
            visible={visible}
            style={{ width: "50vw" }}
            className="z-top modal-styles invite-user"
            onHide={() => setVisible(false)}>
            <InviteUserComponent
              otherValues={otherValues}
              id={id}
              apiClient={apiClient}
              label={label}
              advisory={advisory}
              domain={domain}
              onInvite={handleHide}
              emailValidationMsg={emailValidationMsg}></InviteUserComponent>
          </Dialog>
        </div>
        <div className="sectionHeaderTable">
          <span>Authorised Representative</span>
        </div>
        <FrontEndTable columns={userLinkListTable(isManager, otherValues?.authorisationLevel != null)} data={data} header="" />
      </div>
    </>
  );
}
